import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  pushToHistoryAction,
  setWheelPortrait,
} from "../../../../redux/reducers/segmentBuilder";
import { getWheelImage } from "../../../../redux/selectors/segmentBuilderSelectors";
import ImageCropper from "../../../ImageCropper";
import MediaSelection from "../../Shared/MediaSelection";
import UploadedImage from "./UploadedImage";
import UploadedMedia from "../../Shared/UploadedMedia";

export default function PortraitTab() {
  const selectedImage = useSelector(getWheelImage);
  const wheelInformation = useSelector((state) => state.segmentBuilder);

  const [image, setImage] = useState(
    selectedImage?.url ||
      wheelInformation?.history[wheelInformation?.currentIndex]
        ?.wheel_center_media?.url
  );
  const [imageTitle, setImageTitle] = useState("");
  const [open, setOpen] = useState(false);
  const [originalImage, setOriginalImage] = useState(
    selectedImage?.url || null
  );

  const dispatch = useDispatch();

  const handleImage = (val) => {
    setOriginalImage(val.src);
    setImage(val.src);
    setImageTitle(val.title);
    dispatch(setWheelPortrait({ type: "image", url: val.src }));
    dispatch(pushToHistoryAction()); // Push the new state to history
  };

  const handleEditImage = (val) => {
    setImage(val);
    dispatch(setWheelPortrait({ type: "image", title: imageTitle, url: val }));
    dispatch(pushToHistoryAction()); // Push the new state to history
  };

  const handleRemoveImage = () => {
    setImage(null);
    dispatch(setWheelPortrait({ type: "image", title: "", url: "" }));
    dispatch(pushToHistoryAction()); // Push the new state to history
  };

  console.log(image, "imageimageimageimageimage", selectedImage?.url);

  return (
    <div>
      {image && (
        <UploadedImage
          handleRemoveImage={handleRemoveImage}
          image={image}
          title={imageTitle}
          setOpen={setOpen}
        />
      )}

      <MediaSelection
        type={"image"}
        handleChange={(_, val) => handleImage(val)}
        showEmbedDisclaimer={true}
      />

      <ImageCropper
        src={originalImage}
        open={open}
        handleClose={() => setOpen(false)}
        handleEditImage={handleEditImage}
        isWheelPortrait
      />
    </div>
  );
}
